import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css';
import { SwipeCell } from 'vant';
import { Button } from 'vant';
// 引入组件样式
import { Card } from 'vant';
import { Empty } from 'vant';
import { Divider } from 'vant';
// 注册你需要的组件
createApp(App).use(store).use(Card).use(Button).use(SwipeCell).use(Empty).use(Divider).use(router).mount('#app')
